<template>
  <NuxtLink :href="props.href" :target="targetComputed">
    <template v-if="linkTextComputed">{{ linkTextComputed }}</template>
    <slot v-else />
  </NuxtLink>
</template>

<script setup lang="ts">
import type { PropType } from "vue"

const props = defineProps({
  href: {
    type: String,
    default: "",
  },
  target: {
    type: String as PropType<
      | "_blank"
      | "_parent"
      | "_self"
      | "_top"
      | (string & object)
      | null
      | undefined
    >,
    default: undefined,
    required: false,
  },
})

const targetComputed = computed(() => {
  if (props.target === undefined) {
    return props.href.startsWith("http") ? "_blank" : undefined
  }
  return props.target
})

const linkTextComputed = computed(() => {
  if (
    props.href.startsWith(
      "https://github.com/dixhuit/unitcrunch-issue-tracker/issues/"
    )
  ) {
    // Extract the issue number from the URL
    const issueNumber = props.href.split("/").pop()
    return `#${issueNumber}`
  }
  return null
})
</script>
